/**
 * creating namespace for holding utils, config and config and basic setup
 * for GMS Application
 */
define(
    'atn/atn',[
        './config', './utils', './restUtils', './atnEvents', './jquerySetup',
        './dataCache', './toasterRegistry', './globals', 'lodash'
    ],
    function(config, utils, restUtils, atnEvents, jquerySetup, dataCache, toasterRegistry, globals, _) {
        'use strict';

        var atn = {
            config: config,
            utils: utils,
            rest: restUtils,
            atnEvents: atnEvents,
            dataCache: dataCache,
            toasterRegistry: toasterRegistry 
        };

        _.assign(atn, globals);

        return atn;
    });
